export default "__VITE_ASSET__MVesuDeE__"